// eslint-disable-next-line @typescript-eslint/no-var-requires
export const version = 'CLOUD-20250822-01';
